import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/$workspaceName/$environment/admin/organizations')({
  component: AdminOrganizationsRoute,
})

function AdminOrganizationsRoute() {
  return <Outlet />
}
